export default {
    methods: {
        itIsFillField(value) {
            if (!value) {
                return false;
            }

            if (value === '–' || value === '-' || value === '—') {
                return false;
            }

            return value.length > 1;
        },
        parseItem(item, concatRealization = false) {
            const property = item.props || item.properties;
            const realizationType = property.implementation_object_type || '–';
            let concatTitleAdd = realizationType;
            if (this.itIsFillField(realizationType)) {
                concatTitleAdd += ' по&nbsp;адресу:';
            } else {
                concatTitleAdd = '';
            }

            const title = concatRealization
                ? `${concatTitleAdd} ${item.name}`
                : item.name || '–';
            return {
                id: item.id,
                title,
                picture: item.picture || null,
                price: property.start_price_display || '–',
                auction_number: property.auction_number || '–',
                auctionDate: (property.application_end_date && property.application_end_date.split(' ')[0]) || '–',
                auctionStart: (property.application_end_date && property.application_end_date.split(' ')[0]) || '–',
                auctionDateArch: (property.date_auction || '–'),
                square: property.area || '–',
                realizationType,
                link: item.url || '#',
            };
        }
    },
};
